import { makeStyles } from '@mui/styles';

const styles = makeStyles((theme) => ({
  initContainer: {
    paddingTop: 20,
    paddingBottom: '60vh',
  },
  grid: {
    margin: 'auto',
    marginTop: 20,
  },
}));

export default styles;
